import { adminApi, adminAuthApi } from "./api";

/* SCHOOL RECORD MAIN */
// GET : 학생 리스트 조회
export const adminGetUserListForSchoolRecordApi = (searchTerm) => adminAuthApi.get(`/school-record/users?searchTerm=${searchTerm}`)

// GET : 생활기록부 설정값 조회
export const getSchoolRecordSettingApi = () => adminApi.get(`/school-record/settings`)

// POST : 생활기록부 설정값 저장
export const saveSchoolRecordSettingApi = (requestData) => adminAuthApi.post(`/school-record/settings`, requestData)

/* Reply */
export const adminGetSchoolRecordReplyApi = (schoolRecordId) => adminAuthApi.get(`/school-record/reply/${schoolRecordId}`)
export const adminSaveSchoolRecordReplyApi = (requestData) => adminAuthApi.post(`/school-record/reply`, requestData)
export const adminDeleteSchoolRecordReplyApi = (replyId) => adminAuthApi.delete(`/school-record/reply/${replyId}`)
export const adminUpdateSchoolRecordReplyApi = (requestData) => adminAuthApi.post(`/school-record/reply/update`, requestData)



/* School Record - Old Version (ver1) */
// // GET : 조회
export const adminGetSchoolRecordApi = (userId) => adminAuthApi.get(`/school-record/${userId}`)

// // POST: 저장
export const adminSaveSchoolRecordApi = (data, userId) =>
    adminAuthApi.post(
        `/school-record/${userId}`, data,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    )



/* School Record - new (ver1-1) */
// GET: 생활기록부 new 리스트 조회
export const adminGetSchoolRecordListApi = (userId, searchTerm) => adminAuthApi.get(`/school-record/list/${userId}?searchTerm=${searchTerm}`)

// GET: 생활기록부 new 조회
export const adminGetSchoolRecordDataApi = (schoolRecordId) => adminAuthApi.get(`/school-record/${schoolRecordId}`)

// POST: 생활기록부 new 저장
export const adminSaveSchoolRecordNewApi = (formData) =>
    adminAuthApi.post(
        `/school-record/new`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    )

// DELETE: 생활기록부 new 삭제
export const adminDeleteSchoolRecordApi = (schoolRecordId) => adminAuthApi.delete(`/school-record/${schoolRecordId}`)



/* School Record - ver2 */
// GET: 생활기록부ver2 리스트 조회
export const adminGetSchoolRecordVer2ListApi = (userId, searchTerm) => adminAuthApi.get(`/school-record/ver2/list/${userId}?searchTerm=${searchTerm}`)

// GET: 생활기록부ver2 조회
export const adminGetSchoolRecordVer2Api = (schoolRecordId) => adminAuthApi.get(`/school-record/ver2/${schoolRecordId}`)

// POST: 생활기록부ver2 저장 
export const adminSaveSchoolRecordVer2Api = (formData) =>
    adminAuthApi.post(
        `/school-record/ver2`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    )

// DELETE: 생활기록부ver2 삭제
export const adminDeleteSchoolRecordVer2Api = (schoolRecordId) => adminAuthApi.delete(`/school-record/ver2/${schoolRecordId}`)

// POST: 생활기록부 개인별 열람 권한 설정
export const schoolRecordPermissionApi = (requestData) => adminAuthApi.post(`/school-record/permission`, requestData)
